<template>
  <div v-if="user && (mode === 'create' || user.id)">

    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <div class="box">
        <div
          class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2"
          v-if="mode !== 'create'"
         >
          <div class="flex flex-wrap items-center">
            <p class="text-3xl font-bold leading-none">{{ user.name }}</p>
            <div class="ml-2 leading-none border-l pl-2 border-white light:border-black">
              <p class="text-xs font-bold">Created at:</p>
              <p>
                {{ $moment(user.created_at).format(config.dateTimeFormats.display) }}
              </p>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-red text-xs text-black"
            @click.stop="deleteUser(user.id)"
            v-if="user.id !== User.id"
          >
            <i class="fas fa-trash"></i>
            <span class="ml-1">Delete</span>
          </button>
        </div>


        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="full-name">Name</label>
            <ValidationProvider
              rules="required"
              name="full name"
              v-slot="{ errors }"
            >
              <input
                name="full-name"
                type="text"
                id="full-name"
                class="form-control"
                v-model="user.name"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="email">Email</label>

            <ValidationProvider
              :rules="emailValidation.rules"
              name="email"
              v-slot="{ errors }"
            >
              <input
                name="email"
                type="email"
                id="email"
                class="form-control"
                v-model="user.email"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap mt-4">
          <div class="w-full md:w-1/2">
            <label class="block text-xs font-bold mb-2" for="role">Role</label>
            <ValidationProvider
              rules="required"
              name="role"
              v-slot="{ errors }"
            >
              <div class="relative">
                <select
                  class="form-control pr-8"
                  id="role"
                  v-model="user.roles"
                >
                  <option :value="[role]" v-for="(role, i) in roles" :key="'role-' + i">{{ role.name }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap mt-4" v-if="!isAdmin && User.id === user.id">
          <div class="w-full md:w-1/2">
            <label class="block text-xs font-bold mb-2" for="current-password">Current password</label>
              <ValidationProvider
                rules="required"
                name="current-password"
                v-slot="{ errors }"
              >
                <input
                  name="current-password"
                  id="current-password"
                  class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                  v-model="currentPassword"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 mt-4" v-if="isAdmin || User.id === user.id">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="password">Password</label>
              <ValidationProvider
                vid="password"
                name="password"
                v-slot="{ errors }"
              >
                <div class="flex items-center">
                  <input
                    ref="password"
                    name="password"
                    :type="passwordType.password"
                    id="password"
                    class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                    v-model="password"
                  >
                  <button
                    type="button"
                    class="h-10 px-5 btn-blue rounded-r focus:outline-none"
                    @click="toggleFormType('password')"
                  >
                    <i class="fas" :class="passwordType.password === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
                  </button>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="password-confirmation">Password confirmation</label>
              <ValidationProvider
                rules="confirmed:password"
                name="password confirmation"
                v-slot="{ errors }"
              >
                <div class="flex items-center">
                  <input
                    ref="password-confirmation"
                    name="password-confirmation"
                    :type="passwordType.passwordConfirm"
                    id="password-confirmation"
                    class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                    v-model="passwordConfirmation"
                  >
                  <button
                    type="button"
                    class="h-10 px-5 btn-blue rounded-r focus:outline-none"
                    @click="toggleFormType('passwordConfirm')"
                  >
                    <i class="fas" :class="passwordType.passwordConfirm === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
                  </button>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>

          </div>
        </div>

        <div class="box p-2 pt-8 flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
          </button>
        </div>
      </div>
    </ValidationObserver>

  </div>
</template>


<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    createAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mode: null,
      editID: null,
      userID: this.$route.params.userID,
      initial: {},
      user: {},
      roles: [],
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
      passwordType: {
        password: 'password',
        passwordConfirm: 'password',
      }
    }
  },
  computed: {
    emailValidation() {
      let rules = 'required'
      let delay = 0
      if (this.mode === 'create' || this.user.email !== this.initial.email) {
        rules = 'required|email-available'
        delay = 450
      }
      return {rules, delay}
    },
    ...mapGetters({
      config: 'config/config',
      User: 'user/user',
      isAdmin: 'user/isAdmin',
    })
  },
  mounted() {
    this.setMode()
  },
  methods: {
    toggleFormType(key) {
      if (!this.passwordType[key]) {
        return false
      }
      this.passwordType[key] = this.passwordType[key] === 'password' ? 'text' : 'password'
    },
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'user' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.userID) {
        this.editID = this.userID
        this.mode = 'edit'
      } else if (this.$route.params.userID) {
        this.editID = this.$route.params.userID
      }

      this.getRoles()
      if (this.mode === 'create') {
        this.user = this.emptyUser()
      } else {
        this.get()
      }
    },
    emptyUser() {
      return {
        name: '',
        email: '',
        roles: [],
        created_at: this.$moment(),
      }
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            this._reset()
          }
        })
    },
    _reset() {
      this.user = {}
      this.roles = []
      this.currentPassword = ''
      this.password = ''
      this.passwordConfirmation = ''
      this.getRoles()
      if (this.mode === 'create') {
        this.user = Object.assign({}, this.emptyUser())
      } else {
        this.get()
      }
    },
    deleteUser(userID) {
      this.$swal.fire({
        title: 'Delete user',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('users/' + userID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.$router.push('/administration/user/list')
              })
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      if (this.password !== this.passwordConfirmation) {
        this.$swal.fire({
          title: 'Error',
          text: 'Passwords do not match',
          type: 'error',
        })
        return
      }
      if (this.mode === 'create' && !this.password) {
        this.$swal.fire({
          title: 'Error',
          text: 'Please choose a password',
          type: 'error',
        })
        return
      }
      this.user.current_password = this.currentPassword
      this.user.change_password = this.password

      this.user.role_names = this.user.roles.map(r => r.name)

      // create / update
      if (this.mode === 'create') {
        // only for proper naming convention
        this.user.password = this.user.change_password

        axios.post('users', this.user)
          .then((response) => {
            this.$emit('created', response.data)
            this._reset()

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'User created successfully!',
                type: 'success',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push('/administration/user/list')
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('users/' + this.user.id, this.user)
          .then(() => {
            this.currentPassword = ''
            this.password = ''
            this.passwordConfirmation = ''
            this.$swal.fire({
              title: 'Done',
              text: 'User updated successfully!',
              type: 'success',
            })
            this.$emit('updated', this.user)
            if (this.user.id === this.User.id) {
              this['user/getUser']()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getRoles() {
      axios.get('users/roles')
        .then((response) => {
          this.roles = Object.assign([], response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'User not found',
            type: 'warning',
          })
        })
    },
    get() {
      axios.get('users/' + this.userID)
        .then((response) => {
          this.initial = Object.assign({}, response.data)
          this.user = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'User not found',
            type: 'warning',
          })
        })
    },
    ...mapActions([
      'user/getUser',
    ])
  }
}
</script>
